export * from './check-if-job-position-is-global';
